export default __webpack_public_path__ + "static/media/thsarabunnew_bold-webfont.a1540f66.ttf";